import { render, staticRenderFns } from "./PublishedTable.vue?vue&type=template&id=493ff462&scoped=true"
import script from "./PublishedTable.vue?vue&type=script&lang=js"
export * from "./PublishedTable.vue?vue&type=script&lang=js"
import style0 from "./PublishedTable.vue?vue&type=style&index=0&id=493ff462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ff462",
  null
  
)

export default component.exports